import { Directive, HostBinding, Input, OnInit } from '@angular/core';
import { PermissionService } from '@lib/services/permission.service';

@Directive({
    selector: '[appDisableButtonIfUnauthorized]',
})
export class AccessControlDisableButtonDirective implements OnInit {
    @HostBinding('disabled') disabled!: boolean;
    @Input() appDisableButtonIfUnauthorized!: string;
    @Input() setDisabledProperty!: boolean;

    constructor(private permissionService: PermissionService) {}

    ngOnInit(): void {
        this.canModify(this.appDisableButtonIfUnauthorized);
    }

    private canModify(permissions: string) {
        if (!this.setDisabledProperty) {
            const allPermissions = this.permissionService.getPermissions();
            if (allPermissions && allPermissions.some((permission) => permission === permissions)) {
                this.disabled = false;
            } else {
                this.disabled = true;
            }
        } else {
            this.disabled = true;
        }
    }
}
